import axios from 'axios';
import { getRelatedArticles, getSectionsDictionary } from '~/src/repositories/cms/shared/cms.base.repository';
import { CmsCategoryCodeEnum } from '~/src/models/enums/cms.enum';
import { getMappedMainToolsBlockData } from './utils/cms.main-tools-block.utils';
import { getMappedUpperBlockData } from '~/src/repositories/cms/entities/main/utils/cms.upper-block.utils';
import { getMappedRelatedArticlesData } from '~/src/repositories/cms/entities/main/utils/cms.related-articles.utils';
import { getMappedFaqData } from '~/src/repositories/cms/entities/main/utils/cms.faq-list.utils';
import { getMappedReviewsAgentsData } from '~/src/repositories/cms/entities/main/utils/cms.reviews-agents.utils';
import { getMappedTargetAudienceData } from '~/src/repositories/cms/entities/main/utils/cms.target-audience.utils';
import { getMappedServicesListData } from '~/src/repositories/cms/entities/main/utils/cms.services-list.utils';
import type {
    CmsUpperBlockAttributeInterface,
} from '~/src/repositories/cms/entities/main/types/cms.upper-block.types';
import type {
    CmsMainToolsBlockAttributeInterface,
} from '~/src/repositories/cms/entities/main/types/cms.main-tools-block.types';
import type { CmsFaqListArticleAttributeInterface } from '~/src/repositories/cms/entities/main/types/cms.faq-list.types';
import type {
    CmsServicesListArticleAttributeInterface
} from '~/src/repositories/cms/entities/main/types/cms.services-list.types';
import type {
    CmsReviewsAgentsArticleAttributeInterface
} from '~/src/repositories/cms/entities/main/types/cms.reviews-agents.types';
import type {
    CmsTargetAudienceArticleAttributeInterface
} from '~/src/repositories/cms/entities/main/types/cms.target-audience.types';

export const getReviewsAgents = async (isSSR?: boolean) => {
    const data = await getSectionsDictionary<CmsReviewsAgentsArticleAttributeInterface>({
        isSSR,
        categoryCode: CmsCategoryCodeEnum.REVIEWS_AGENTS,
    });

    return getMappedReviewsAgentsData(data);
};

export const getTargetAudienceAgents = async (isSSR?: boolean) => {
    const data = await getSectionsDictionary<CmsTargetAudienceArticleAttributeInterface>({
        isSSR,
        categoryCode: CmsCategoryCodeEnum.TARGET_AUDIENCE,
    });

    return getMappedTargetAudienceData(data);
};

export const getMtsServicesList = async (isSSR?: boolean) => {
    const data = await getSectionsDictionary<CmsServicesListArticleAttributeInterface>({
        isSSR,
        categoryCode: CmsCategoryCodeEnum.POTENTIAL_PROFIT,
    });
    return getMappedServicesListData(data);
};

export const getFaqList = async (isSSR?: boolean) => {
    const data = await getSectionsDictionary<CmsFaqListArticleAttributeInterface>({
        isSSR,
        categoryCode: CmsCategoryCodeEnum.MAIN_QUESTIONS,
    });
    return getMappedFaqData(data);
};

export const getRelatedArticlesData = async (articleId: number, isSSR?: boolean) => {
    const data = await getRelatedArticles({
        isSSR: isSSR,
        articleId: articleId,
    });

    if ('cmsFailed' in data) {
        return { cmsFailed: true };
    }

    return getMappedRelatedArticlesData(Array.isArray(data) ? data : [data]);
};

export const getRelatedArticlesViaApi = async (articleId: number) => {
    try {
        const { data } = await axios.get(`/api/next/external-api/v3/articles/${articleId}/related-articles`, {
            params: { articleId },
        });

        if ('cmsFailed' in data) {
            return { cmsFailed: true };
        }

        return getMappedRelatedArticlesData(Array.isArray(data) ? data : [data]);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('API route fetch error:', error);
        return { cmsFailed: true };
    }
};

export const getUpperBlockData = async (isSSR?: boolean) => {
    const data = await getSectionsDictionary<CmsUpperBlockAttributeInterface>({
        isSSR,
        categoryCode: CmsCategoryCodeEnum.UPPER_BLOCK,
    });
    return getMappedUpperBlockData(data);
};

export const getMainToolsBlockData = async (isSSR?: boolean) => {
    const data = await getSectionsDictionary<CmsMainToolsBlockAttributeInterface>({
        isSSR,
        categoryCode: CmsCategoryCodeEnum.MAIN_TOOLS,
    });
    return getMappedMainToolsBlockData(data);
};
